import { useEffect, useState, useCallback } from 'react'
import { TbLoader2 } from 'react-icons/tb'
import { useDispatch, useSelector } from 'react-redux'
import InfiniteScroll from 'react-infinite-scroll-component'

// antd
import { Empty } from 'antd'

// slices
import {
    jobState,
    changePage,
    getListJobs,
    searchJob,
    filterChange,
    clearFilter,
    switchJobModal,
} from './store/job.slice'

// components
import PanelHeader from '../../components/panelHeader/panelHeader'
import JobCards from './components/JobCards'

// helpers
import { unique } from '../../helpers/uniqueArray'
import AddEditJob from './components/AddEditJob'

function Jobs() {
    const dispatch = useDispatch()

    const {
        modalVariations,
        pageLimit,
        isNext,
        status,
        jobList,
        skipPage,
        filter,
        search,
    } = useSelector(jobState)

    const initialState = {
        jobView: 'grid',
        filteredJobData: [],
    }

    // STATE
    const [state, setState] = useState(initialState)

    // CHECK FOR LAZY LOADING IS_NEXT - Merge new jobs into filtered data
    useEffect(() => {
        if (jobList?.length > 0) {
            let array = []
            jobList?.length > 0 &&
                jobList.forEach((data) => {
                    array = [...array, data]
                })
            let newArray = [...state?.filteredJobData, ...array]
            let finalArray = unique(newArray, '_id')
            setState((prevState) => ({
                ...prevState,
                filteredJobData: finalArray,
            }))
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [jobList])

    // REFRESH PAGE
    function refreshPage() {
        setState((prevState) => ({
            ...prevState,
            filteredJobData: [],
        }))
        dispatch(
            changePage({
                currentPage: 1,
                skip: 0,
                pageLimit,
            })
        )
    }

    const initialJobCall = (search) => {
        setState((prevState) => ({
            ...prevState,
            filteredJobData: [],
        }))
        dispatch(
            changePage({
                currentPage: 1,
                skip: 0,
                pageLimit: state?.jobView === 'grid' ? pageLimit : 10,
            })
        )
        dispatch(
            getListJobs({
                limit: state?.jobView === 'grid' ? pageLimit : 10,
                skip: 0,
                search: search,
                filter: { ...filter },
            })
        )
    }

    // Fetch more jobs for lazy loading
    const fetchMoreJobs = useCallback(() => {
        if (isNext && status !== 'loading') {
            const nextSkip = skipPage + pageLimit
            dispatch(
                changePage({
                    currentPage: Math.floor(nextSkip / pageLimit) + 1,
                    skip: nextSkip,
                    pageLimit: state?.jobView === 'grid' ? pageLimit : 10,
                })
            )
            dispatch(
                getListJobs({
                    limit: state?.jobView === 'grid' ? pageLimit : 10,
                    skip: nextSkip,
                    search: search || '',
                    filter: { ...filter },
                })
            )
        }
    }, [
        isNext,
        status,
        skipPage,
        pageLimit,
        dispatch,
        state?.jobView,
        filter,
        search,
    ])

    // GET INITIAL TALENT LIST
    useEffect(() => {
        initialJobCall('')
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const rootSubmenuKeys = ['verification', 'status']

    return (
        <>
            <div
                className={'container'}
                style={{
                    zIndex: 10,
                    minHeight: '100vh',
                    padding: '35px',
                }}
            >
                <>
                    <PanelHeader
                        props={{
                            panelName: 'add job',
                            panelHeaderName: 'Job',
                            searchBar: true,
                            filterBar: false,
                            isCount: false,
                            teamMembersBar: false,
                            permissionAdd: true,
                            gridView: false,
                            rootSubmenuKeys,
                            filterType: null,
                            action: getListJobs,
                            search: searchJob,
                            changeFilter: filterChange,
                            clearFilter: clearFilter,
                            pageLimit: pageLimit,
                            skipPage: skipPage,
                            filterValue: {
                                ...filter,
                            },
                            changePageGrid: () => {
                                dispatch(
                                    changePage({
                                        currentPage: 1,
                                        skip: 0,
                                        pageLimit: 10,
                                    })
                                )
                            },

                            clearData: () =>
                                setState((prevState) => ({
                                    ...prevState,
                                    filteredJobData: [],
                                })),
                            refreshPage: refreshPage,
                            onClick: () => {
                                dispatch(
                                    switchJobModal({
                                        ...modalVariations,
                                        open: true,
                                    })
                                )
                            },
                        }}
                    />

                    {status === 'loading' &&
                    state?.filteredJobData?.length === 0 ? (
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                height: '50vh',
                                width: '100%',
                            }}
                        >
                            <TbLoader2
                                size={36}
                                className="spin-loader-resume"
                                color="#4f46e5"
                            />
                        </div>
                    ) : (
                        <InfiniteScroll
                            dataLength={state?.filteredJobData?.length || 0}
                            next={fetchMoreJobs}
                            hasMore={isNext}
                            loader={
                                <div
                                    style={{
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        padding: '20px',
                                        width: '100%',
                                    }}
                                >
                                    <TbLoader2
                                        size={24}
                                        className="spin-loader-resume"
                                        color="#4f46e5"
                                    />
                                </div>
                            }
                            endMessage={null}
                            style={{
                                overflow: 'inherit',
                            }}
                        >
                            <div
                                style={{
                                    display: 'flex',
                                    flexWrap: 'wrap',
                                    gap: 20,
                                }}
                            >
                                {state?.filteredJobData?.length > 0 ? (
                                    state.filteredJobData.map((job, index) => (
                                        <JobCards
                                            key={job._id || index}
                                            job={job}
                                        />
                                    ))
                                ) : (
                                    <div
                                        style={{
                                            display: 'flex',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            height: '50vh',
                                            width: '100%',
                                        }}
                                    >
                                        <Empty />
                                    </div>
                                )}
                            </div>
                        </InfiniteScroll>
                    )}
                </>
            </div>

            <AddEditJob />
        </>
    )
}

export default Jobs
